import { IDLE } from "../../global/statusLabels";
import { POST_LOGIN_SUCCESS, RESET_POST_LOGIN_STATE } from "./actionsType";

export const initialState = {

    postLogin: { value: false, status: IDLE },

}

export const postLoginReducer = (state = initialState, action) => {

    switch (action.type) {

        case POST_LOGIN_SUCCESS:
            return {
                ...state,
                postLogin: action.payload
            }


        case RESET_POST_LOGIN_STATE:
            return initialState

        case 'persist/REHYDRATE':
            return state;

        default:
            return state;
    }
}